import menu from "./vi-VN/menu";
import pages from "./vi-VN/pages";

export default {
  'navBar.lang': 'Languages',
  ...menu,
  ...pages,
};
